"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorPageLayout = void 0;
var _shared = require("@ori-appshell/shared");
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _featureToggles = require("@ori/feature-toggles");
var _logger = require("@ori/logger");
var _login = require("@ori/login");
var _head = _interopRequireDefault(require("next/head"));
var _react = _interopRequireWildcard(require("react"));
var _Footer = require("../../components/Footer");
var _TopArea = require("../../components/TopArea");
var _constantsGenerated = require("../../constants-generated");
var _internals = require("../../internals");
var _ErrorPageLayoutFeature = require("./ErrorPageLayoutFeature");
var _ErrorPageTranslationsProvider = require("./ErrorPageTranslationsProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ErrorPageLayout = ({
  children,
  customerId,
  developmentInfo,
  environment,
  features,
  language,
  serviceUrls,
  shouldRefetchtranslations,
  tenant,
  token,
  translations
}) => {
  const devInfoFeatures = (0, _react.useMemo)(() => (0, _internals.mapFeatureToggles)(features, _ErrorPageLayoutFeature.ErrorPageLayoutFeature), [features]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_head.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "origin",
        content: `ASMS - ${developmentInfo.serviceName}`
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_environment.EnvironmentProvider, {
      environment: environment,
      tenant: tenant,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_configurationManager.ServiceUrlsProvider, {
        serviceUrls: serviceUrls,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_auth.UniversalTokenProvider, {
          initialToken: token,
          customerId: customerId,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.AppInsightsProvider, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.EmotionCacheProvider, {
              cacheKey: _constantsGenerated.EMOTION_CACHE_KEY,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.ThemeProvider, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_featureToggles.FeatureTogglesProvider, {
                  toggles: features,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorPageTranslationsProvider.ErrorPageTranslationsProvider, {
                    shouldRefetchtranslations: shouldRefetchtranslations,
                    language: language,
                    staticApiUrl: serviceUrls.staticApiUrl ?? '',
                    tenant: tenant,
                    translations: translations,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_login.LoginProvider, {
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.DevelopmentInfoScript, {
                        info: developmentInfo,
                        tenant: tenant,
                        featureToggles: devInfoFeatures
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopArea.TopAreaLoader, {}), children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.FooterLoader, {})]
                    })
                  })
                })
              })
            })
          })
        })
      })
    })]
  });
};
exports.ErrorPageLayout = ErrorPageLayout;
